/*Date.prototype.toJSON = function(){
	this.setHours(this.getHours() - this.getTimezoneOffset() / 60);
    return this.toISOString();
};*/
window.RandExp = require("randexp");
window.swal = require("sweetalert2");
window.$ = require('jquery');
window.toastr = require('toastr');
window._ = require("lodash");
require("vue-js-modal");
require("vue-select");
window.url = "";
window.axios = require("axios");
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
var Prism = require("prismjs");
var Normalizer = require("prismjs/plugins/normalize-whitespace/prism-normalize-whitespace");
var nw = new Normalizer({
  "remove-trailing": true,
  "remove-indent": true,
  "left-trim": true,
  "right-trim": true,
});
window.money = {
  numeral: true,
  numeralDecimalScale: 2,
  numeralPositiveOnly: true,
  prefix: "$ ",
  rawValueTrimPrefix: true,
};

window.decimal = {
  numeral: true,
  numeralDecimalScale: window.precision,
  numeralPositiveOnly: true,
};
window.porcentaje = {
  numeral: true,
  numeralDecimalScale: 2,
  numeralPositiveOnly: true,
  prefix: "% ",
  rawValueTrimPrefix: true,
};
window.int = {
  numeral: true,
  numeralDecimalScale: 0,
  numeralPositiveOnly: true,
};
window.numero = {
  numeral: true,
  numeralDecimalScale: 0,
  numeralPositiveOnly: true,
  numeralThousandsGroupStyle: "none",
  stripLeadingZeroes: false,
};
window.locale = "en-US";
window.uuid = require("uuid/v1");

window.moment = require("moment");

window.round = function(number) {
  return Math.round(number * 100 + Number.EPSILON) / 100;
};
window.moneyNegative = {
  numeral: true,
  numeralDecimalScale: 2,
  numeralPositiveOnly: false,
  prefix: "$ ",
  rawValueTrimPrefix: true,
};
window.porcentajeNegative = {
  numeral: true,
  numeralDecimalScale: 2,
  numeralPositiveOnly: false,
  prefix: "% ",
  rawValueTrimPrefix: true,
};
window.format = require("format-number");
window.moneyFormat = window.format({
  prefix: "$",
  decimalSeparator: ".",
  integerSeparator: ",",
  round: 2,
  padRight: 2,
});
window.decimalFormat = window.format({
  prefix: "",
  decimalSeparator: ".",
  integerSeparator: ",",
  round: 2,
  padRight: 2,
});



// WEBPACK FOOTER //
// ./resources/assets/js/bootstrap.js